import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import moment from 'moment'

const HeaderMenuManage = (props) => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: 0,
            table: 'header_menus',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })
    const validationArray = Yup.object({
        menu_name: Yup.string().required('Required!'),
        menu_value: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            menu_name: '',
            menu_value: '',
            menu_type: 'tag',
            type: 'header',
            table: 'header_menus',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            console.log('+++++++++++++', values)
            searchTableAction(values)
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'header_menus') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    useEffect(() => {
        if (data.status === 'edit') {
            formik.setValues({
                ...data,
                id: data.id,
                table: 'header_menus',
            })
            formik.setFieldValue('id', data.id)
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,
            menu_name: '',
            menu_value: '',
            menu_type: 'tag',
            type: 'header',
            table: 'header_menus',
        })
    }
    const details = {
        formik: formik,
        data: [
            {
                label: 'Type',
                placeholder: 'Type',
                type: 'select',
                class: 'col-12',
                name: 'type',
                options: [
                    {
                        show: 'Header',
                        value: 'header',
                    },
                    {
                        show: 'Footer',
                        value: 'footer',
                    },
                ],
                defaultOptionValue: 'header',
            },
            {
                label: 'Menu Title',
                placeholder: 'Menu Title',
                type: 'text',
                class: 'col-12',
                name: 'menu_name',
            },
            {
                label: 'Menu Type',
                placeholder: 'Menu Type',
                type: 'select',
                class: `${
                    formik.values.type === 'header' ? 'col-12' : 'd-none'
                }`,
                name: 'menu_type',
                options: [
                    {
                        show: 'Tag',
                        value: 'tag',
                    },
                    {
                        show: 'Link',
                        value: 'link',
                    },
                ],
                defaultOptionValue: 'tag',
            },
            {
                label: 'Keywords',
                placeholder: 'Enter Keywords',
                class: `${
                    formik.values.menu_type === 'tag' ? 'col-12' : 'd-none'
                }`,
                type: 'tagsInput',
                name: 'menu_value',
                options: [],
                filter: false,
                multiple: true,
                active: 1,
                view_page: 1,
            },
            {
                label: 'Link',
                placeholder: 'Enter Link',
                class: `${
                    formik.values.menu_type === 'link' ? 'col-12' : 'd-none'
                }`,
                type: 'text',
                name: 'menu_value',
                options: [],
                filter: false,
                multiple: true,
                active: 1,
                view_page: 1,
            },
        ],
    }

    useEffect(() => {
        if (formik.values.type === 'footer') {
            formik.values.menu_type = 'link'
        }
    }, [formik.values.type])

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }
    const submitFunction = () => {
        console.log('i am here submit ', formik)
        formik.handleSubmit()
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Header Menu'
                    : 'Edit Header Menu'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    <div className="row">{mapData(details)}</div>
                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default HeaderMenuManage
